<template>
  <v-app>
    <v-container fluid class="my-4 google-font">
      <v-layout align-center justify-center row>
        <v-flex xs12 lg8 xl6>
          <v-card>
            <RequestQuote
              headerText="Book a Demo"
              headerSubtext="We will contact you to book a call"
              :showVolume="false"
              cta="Request Demo"
            />
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import RequestQuote from "@bugseq-site/www/src/components/pricing/RequestQuote.vue";

@Component({
  metaInfo() {
    return {
      title: "Book a Demo",
    };
  },
  components: {
    RequestQuote,
  },
})
export default class BookDemoPage extends Vue {}
</script>
